export function PlayerInviteModalBody({ children }) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto flex flex-col mt-2">
      {children}
    </div>
  );
}

export function PlayerInviteModalButtons({ children }) {
  return (
    <div className="flex justify-end gap-2 border-t border-gray-200 pt-4">
      {children}
    </div>
  );
}
